import i18n from "@/services/i18n";
import type { LocalizedValue } from "@/services/api/entities/payment/types";

export function getSafeLocalizedValue(
  localizedObject: LocalizedValue | undefined,
  fallbackValue: string | undefined,
): string {
  const lang = i18n.language as keyof LocalizedValue;

  return localizedObject?.[lang] ?? fallbackValue ?? "";
}
